import { PERMISSION_ACTIONS } from './permissionActions';
import { PERMISSION_SUBJECTS } from './permissionSubjects';

const SAT_SIDEBAR_DATA = [
  {
    header: 'SAT MANAGEMENT',
    tabs: [
      {
        tabName: 'Reset SAT',
        to: '/sat-management/reset-sat',
        subject: PERMISSION_SUBJECTS.courseAssessmentMentee,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
      {
        tabName: 'Batch Allocation',
        to: '/sat-management/batch-allocation',
        subject: PERMISSION_SUBJECTS.courseAssessmentMentee,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
    ],
  },
];
export default SAT_SIDEBAR_DATA;
